(function() {
    'use strict';

    angular
        .module('app',['ngSanitize','ui.bootstrap','ui.sortable','colorpicker.module'])
        .config(['$httpProvider', function ($httpProvider) { 
       		$httpProvider.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';
        	// $httpProvider.defaults.headers.post['X-CSRF-Token'] = jQuery('meta[name="csrf-token"]').attr("content");
        	$httpProvider.interceptors.push(['$q',function ($q) {
             return {
                 'request': function (config) {
                 	 var d = new Date();
        			 var baseurl = $('body').attr("data-baseurl");

                     var string = "backend";
                     //console.log(config.url.indexOf(string));
                     //console.log(config.url);
                    if(config.url.indexOf(string) !== -1){
                        config.url = baseurl+config.url;
                        //console.log(config);
                    }
                     
                     return config || $q.when(config);
              	   }
            	 }
         	}]);

    	}]).config(["$interpolateProvider",function($interpolateProvider){
            //console.log("interpoolate",$interpolateProvider);
            $interpolateProvider.startSymbol("[[");
            $interpolateProvider.endSymbol("]]");
        }]);
})();
